import { createModel } from "@rematch/core";
import { CustomerGroupListItem } from "src/lib/models/CustomerGroupListItem";

import { RootModel } from ".";

const initialState: CustomerGroupListItem | null = null;

export const customerGroupEditOption = createModel<RootModel>()({
  state: initialState as CustomerGroupListItem | null,
  reducers: {
    setCustomerGroupEditOption(state, payload: CustomerGroupListItem | null) {
      return payload;
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/customerGroupEditOption.ts